import WaitingForOpponent from "./WaitingForOpponent";

export default WaitingForOpponent;
